/**
 * Check if the element is truncating
 */
export default function isTruncating(element, lines) {
    if (lines > 1) {
        const computedStyle = window.getComputedStyle(element);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const maxHeight = lineHeight * lines;
        return element ? element.scrollHeight - 1 > maxHeight : false;
    }
    return element ? element.scrollWidth > element.clientWidth : false;
}
